'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withTooltip = require('../with-tooltip');

var _withTooltip2 = _interopRequireDefault(_withTooltip);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Addon = function Addon(_ref) {
  var addonType = _ref.addonType,
      addonClasses = _ref.addonClasses,
      numberOfCharactersToTrim = _ref.numberOfCharactersToTrim,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave,
      props = _objectWithoutProperties(_ref, ['addonType', 'addonClasses', 'numberOfCharactersToTrim', 'onMouseEnter', 'onMouseLeave']);

  var shouldTextBeTrimmed = addonType.length >= numberOfCharactersToTrim;

  return _react2.default.createElement(
    'div',
    {
      key: '' + addonType,
      className: addonClasses,
      onMouseEnter: function onMouseEnter(event) {
        if (_onMouseEnter && shouldTextBeTrimmed) {
          _onMouseEnter(event);
        }
      },
      onMouseLeave: function onMouseLeave(event) {
        if (_onMouseLeave && shouldTextBeTrimmed) {
          _onMouseLeave(event);
        }
      }
    },
    shouldTextBeTrimmed && _react2.default.createElement('span', _extends({ className: 'input-tooltip' }, props)),
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(shouldTextBeTrimmed && 'text-truncate') },
      addonType
    )
  );
};

Addon.propTypes = {
  addonType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  addonClasses: _propTypes2.default.string,
  numberOfCharactersToTrim: _propTypes2.default.number,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func
};

Addon.defaultProps = {
  numberOfCharactersToTrim: _utils.CONSTANTS.INPUT_ADDON_MAX_ALLOWED_CHARACTERS
};

exports.default = (0, _withTooltip2.default)(Addon);